
import { useState, useEffect } from 'react';

interface DeviceInfo {
  isIOS: boolean;
  isAndroid: boolean;
  isMobile: boolean;
  isTablet: boolean;
  userAgent: string;
  supportsTouch: boolean;
  devicePixelRatio: number;
}

export const useDeviceDetection = (): DeviceInfo => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceInfo>({
    isIOS: false,
    isAndroid: false,
    isMobile: false,
    isTablet: false,
    userAgent: '',
    supportsTouch: false,
    devicePixelRatio: 1,
  });

  useEffect(() => {
    const userAgent = navigator.userAgent;
    
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);
    const isAndroid = /Android/.test(userAgent);
    const isMobile = /Mobi|Android/i.test(userAgent);
    const isTablet = /iPad/.test(userAgent) || (isAndroid && !/Mobile/.test(userAgent));
    const supportsTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
    const devicePixelRatio = window.devicePixelRatio || 1;

    setDeviceInfo({
      isIOS,
      isAndroid,
      isMobile,
      isTablet,
      userAgent,
      supportsTouch,
      devicePixelRatio,
    });
  }, []);

  return deviceInfo;
};
